import { Component, OnInit, Output, EventEmitter, ViewChild, OnDestroy } from '@angular/core';
import { HttpRepositoryService } from '../../core/http-repository.service';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Campaign } from '../campign.model';
import { Contact } from '../../contacts/contact/contact.model';
import { CampaignType } from '../campaign-type.enum';
import { NgForm } from '@angular/forms';
import { DateTimePickerComponent } from './date-time-picker/date-time-picker.component';
import { SelectContactListComponent, SelectContactList } from './select-contact-list/select-contact-list.component';
import { Buffer } from 'buffer';
import { map } from 'rxjs/operators';
import { ValidateTokenComponent } from './validate-token/validate-token.component';
import { AntiForgeryTokenService } from '../../auth/anti-forgery-token.service';
import { SubSink } from 'subsink';

declare var $: any;
declare var Toast: any;

@Component({
  selector: 'campaign-edit',
  templateUrl: './campaign-edit.component.html',
  styleUrls: ['./campaign-edit.component.css']
})

export class CampaignEditComponent implements OnInit, OnDestroy {
  private campaign: Campaign = new Campaign();
  private isNew: boolean = false;
  private selectedCamapaign: number = 0;
  private navbarHeadline: any;
  private modal: any;
  private wizard: any;
  private wOptions: any;
  private container: any;
  private msgNum: any;
  private isPlainText: boolean = false;
  private onSendOn: boolean = false;
  private onSendUntil: boolean = false;
  private onSendToAll: boolean = true;
  private selectedContactListsName: string[] = [];
  private contactCountFromSelectedContactList: number;
  private selectedSendOnScheduleDate: string;
  private selectedSendUntilScheduleDate: string;
  private campaignTypeName: string;
  private isPhoneValid: boolean = true;
  private contactsFromSelectedContactList: Contact[] = [];
  private selectedSendOn: string;
  private selectedSendUntil: string;
  private outbox: Outbox = new Outbox();
  private previewCampaignRecepient: string;
  private dateTimePickerError: boolean;
  private spinnerBtn: any;
  private successIcon: any;
  private errorIcon: any;
  private selectedContactListId: number[] = [];
  private selectedCompany: number;
  private subs = new SubSink()

  private quillToolbar = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      ['blockquote'],
      [{ 'header': 1 }, { 'header': 2 }],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'indent': '-1' }, { 'indent': '+1' }],
      [{ 'size': ['small', false, 'large', 'huge'] }],
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'font': [] }],
      [{ 'align': [] }],
      ['link', 'image']
    ]
  }

  private quillStyle = {
    'height': '200px'
  }

  @ViewChild('editCampaignForm', { static: false }) editForm: NgForm;
  @ViewChild('sendOn', { static: false }) sendOn: DateTimePickerComponent;
  @ViewChild('sendUntil', { static: false }) sendUntil: DateTimePickerComponent;
  @ViewChild('selectContactList', { static: false }) selectContactList: SelectContactListComponent;
  @ViewChild('validateTokens', { static: false }) validateTokens: ValidateTokenComponent;

  @Output()
  private saved: EventEmitter<Campaign> = new EventEmitter<Campaign>();

  constructor(private repository: HttpRepositoryService, private titleService: Title, private router: Router, private antiForgery: AntiForgeryTokenService) { }

  ngOnInit() {
    let that = this;
    this.modal = $('#wizard');

    document.getElementById('radio-mail-label').style.pointerEvents = 'none';
    document.getElementById('radio-viber-label').style.pointerEvents = 'none';

    this.wOptions = {
      title: 'Campaign wizard',
      size: 'large',
      finishButton: {
        text: 'Finish',
        class: 'btn btn-success',
        closeWizard: true
      },
      nextButton: {
        text: 'Next',
        class: 'btn btn-primary'
      },
      previousButton: {
        text: 'Previous',
        class: 'btn btn-light'
      },
      stepper: {
        visible: true,
        useIcons: true
      },
      verticalAlign: 'top',
      animation: true,
      closeButtonVisible: true,
      onPageChanging: function (current, next, cancel) {
        if (next < current) //Allow prev
          cancel(false)

        if (that.editForm.controls['campaignSubject'].value == "" && current == 0) {
          that.editForm.controls['campaignSubject'].markAsDirty();
          cancel(true);
          return;
        }

        if (that.editForm.controls['smsCampaign']) {
          if (that.editForm.controls['smsCampaign'].value == "" && current == 1) {
            that.editForm.controls['smsCampaign'].markAsDirty();
            cancel(true);
            return;
          }
        }

        if (that.editForm.controls['emailCampaign']) {
          if ((that.editForm.controls['emailCampaign'].value == "" || that.editForm.controls['emailCampaign'].value == null) && current == 1) {
            that.editForm.controls['emailCampaign'].markAsDirty();
            cancel(true);
            return;
          }
        }

        if (that.editForm.controls['viberCampaign']) {
          if (that.editForm.controls['viberCampaign'].value == "" && current == 1) {
            that.editForm.controls['viberCampaign'].markAsDirty();
            cancel(true);
            return;
          }
        }

        if (current == 1 && next == 2) {
          let tokensFromCampaign = that.searchTokens();
          that.validateTokens.setTokensFromCampaign(tokensFromCampaign);
        }

        if (current == 2 && next == 3) {
          if (that.sendOn) {
            that.campaign.sendImmediately = false;

            if (that.sendOn.dateSelect.nativeElement.value == "" && current == 2) {
              cancel(true);
              return;
            }

            if (that.sendOn.selectedHour == "" && current == 2) {
              cancel(true);
              return;
            }

            if (that.sendOn.selectedMinutes == "" && current == 2) {
              cancel(true);
              return;
            }
          }

          if (that.sendUntil) {
            if (that.sendUntil.dateSelect.nativeElement.value == "" && current == 2) {
              cancel(true);
              return;
            }

            if (that.sendUntil.selectedHour == "" && current == 2) {
              cancel(true);
              return;
            }

            if (that.sendUntil.selectedMinutes == "" && current == 2) {
              cancel(true);
              return;
            }

            if (that.campaign.sendImmediately && new Date() > new Date(that.sendUntil.createScheduleString())) {
              that.dateTimePickerError = true;
              cancel(true);
              return;
            }

            that.dateTimePickerError = false;
          }

          if (that.onSendOn) {
            let sendOnSchedule: string = that.sendOn.createScheduleString();
            that.campaign.sendOn = sendOnSchedule;
            that.selectedSendOnScheduleDate = that.sendOn.getScheduleDate();
          } else {
            that.campaign.sendOn = "";
          }

          if (that.onSendUntil) {
            let sendUntilSchedule = that.sendUntil.createScheduleString();
            that.campaign.sendUntil = sendUntilSchedule;
            that.selectedSendUntilScheduleDate = that.sendUntil.getScheduleDate();
          } else {
            that.campaign.sendUntil = "";
          }

          if (that.sendOn && that.sendUntil) {
            if (new Date(that.sendOn.createScheduleString()) > new Date(that.sendUntil.createScheduleString())) {
              that.dateTimePickerError = true;
              cancel(true);
              return;
            }

            that.dateTimePickerError = false;
          }

        }

        if (current == 3 && next == 4) {
          if (that.selectContactList.selectedContactList.length == 0 && (that.onSendOn || that.onSendUntil || that.campaign.sendImmediately)) {
            that.selectContactList.isSelectedContactList = false;
            cancel(true);
            return;
          }

          that.selectedContactListsName = that.selectContactList.getSelectedContactListName();
          that.contactCountFromSelectedContactList = that.selectContactList.getContactCount();

          let selectedContactListId = that.selectContactList.selectedContactList.map(x => x.contactListId);
          that.validateTokens.setSelectedContactList(selectedContactListId);
        }

        if (current == 4 && next == 3) {
          that.validateTokens.resetContactListTokenError();
          that.validateTokens.resetValidateBtn();
        }

        cancel(false);
      },
      onFinishing: function (cancel) {
        let isValidatedTokens = that.validateTokens.isValdate;

        if (that.selectedCamapaign == 0 && !that.isPhoneValid) {
          cancel(true);
        }

        if (!that.validateTokens.isClicked) {
          that.validateTokens.dispErrMsg = true;
        }

        if (!isValidatedTokens) {
          cancel(true);
        } else {
          cancel(false);
        }

      },
      onFinished: function () {
        if (that.isNew) {
          that.insert();
        } else {
          that.update();
        }
      },
      onCanceled: function () {
        that.onClosed();
      }
    }

    this.wizard = this.modal.Wizard(this.wOptions);
  }

  public show(campaign: Campaign, isNew: boolean, type: CampaignType, selectedCompany: number) {
    this.campaign = campaign;
    this.isNew = isNew;
    this.selectedCamapaign = type;
    this.selectedCompany = selectedCompany;
    this.campaignTypeName = Object.keys(CampaignType).find(key => CampaignType[key] == type);
    let selectedContactList: SelectContactList[] = [];
    this.spinnerBtn = $('#spinner');
    this.successIcon = $('#success');
    this.errorIcon = $('#error');

    if (isNew) {
      this.campaign.type = this.campaignTypeName;

      if (campaign.contactLists.length > 0) {
        this.selectContactList.selectedContactList = this.campaign.contactLists; //check selected contactlists
      }
    } else {
      this.selectContactList.selectedContactList = this.campaign.contactLists;
    }


    this.wizard.Show();

    if (type == 0)
      this.countCharacters();

    if (this.campaign.sendOn !== '') {
      this.onSendOn = true;
      this.selectedSendOn = campaign.sendOn;
    }

    if (this.campaign.sendUntil !== '') {
      this.onSendUntil = true;
      this.selectedSendUntil = campaign.sendUntil;
    }
  }

  private selectCampaignType(campaign: number) {
    if (this.selectedCamapaign != campaign) {
      let newCampaign = new Campaign(this.campaign.id, this.campaign.subject, this.campaignTypeName, false, false, false, false, false, this.campaign.content);
      this.campaign = newCampaign;
      this.isPlainText = false;

      if (campaign != 1 && this.campaign.content.length > 0)
        this.campaign.content = this.stripHtmlTags(this.campaign.content);

    }

    this.selectedCamapaign = campaign;
  }

  private insert(): void {
    let selectedCamapignId = this.selectContactList.selectedContactList.map(x => x.contactListId);
    this.campaign.content = this.setTokenToUpperCase(this.campaign.content);

    this.subs.sink = this.antiForgery.getAFToken().subscribe(afResp => {
      if (afResp.hasErrors) {
        Toast.Show(afResp.error, 'Create campaign', 'error');
      } else {

        this.subs.sink = this.repository.post<Campaign>('api/Campaign/Create?companyId=' + this.selectedCompany, this.campaign, afResp.data).pipe(map(x => x)).subscribe(resp => {
          if (resp.statusCode == 200) {

            if (selectedCamapignId.length > 0) {
              let campaignContacList = new CampaignContactList();
              campaignContacList.idCampaign = resp.data.id;
              campaignContacList.idContactList = selectedCamapignId;

              this.subs.sink = this.repository.post<CampaignContactList>('api/Campaign/Assign', campaignContacList, afResp.data).pipe(map(x => x)).subscribe(assignResp => {
                if (assignResp.statusCode == 200) {

                } else {
                  Toast.Show(assignResp.error, 'Create campaign', 'error');
                }
              });
            }

            Toast.Show('Campaign successfully created.', 'Create campaign', 'success');
          } else {
            Toast.Show(resp.error, 'Create campaign', 'error');
          }

          this.onSaveCompleted(resp.data);
        });
      }
    });
  }

  private update() {
    this.campaign.content = this.setTokenToUpperCase(this.campaign.content);

    this.subs.sink = this.antiForgery.getAFToken().subscribe(afResp => {
      if (afResp.hasErrors) {
        Toast.Show(afResp.error, 'Update campaign', 'error');
      } else {
        this.subs.sink = this.repository.put<Campaign>('api/Campaign/Edit?companyId=' + this.selectedCompany, this.campaign, afResp.data).pipe(map(x => x)).subscribe(resp => {
          if (resp.statusCode == 200) {
            Toast.Show('Campaign successfully updated.', 'Update campaign', 'success');
          } else {
            Toast.Show(resp.error, 'Update campaign', 'error');
          }

          this.onSaveCompleted(resp.data);
        });
      }
    });
  }

  private sendPreviewCampaign(data: Campaign) {
    let that = this;

    if (this.successIcon.is(':visible'))
      this.successIcon.hide();

    if (this.errorIcon.is(':visible'))
      this.errorIcon.hide();

    if (this.previewCampaignRecepient) {
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      let hour = date.getHours();
      let minute = date.getMinutes();
      let second = date.getSeconds();
      let dateTime = year + '-'
        + this.appendLeadingZeroes(month) + '-'
        + this.appendLeadingZeroes(day) + ' '
        + this.appendLeadingZeroes(hour) + ':'
        + this.appendLeadingZeroes(minute) + ':'
        + this.appendLeadingZeroes(second);

      this.spinnerBtn.fadeIn('fast');

      this.outbox.idCampaign = data.id;
      this.outbox.sender = 'Testing...';
      this.outbox.recepient = this.previewCampaignRecepient
      this.outbox.subject = '';
      this.outbox.body = data.content;
      this.outbox.distributionMechanism = data.type;
      this.outbox.createdDate = dateTime;
      this.outbox.lastChangedAt = dateTime;
      this.outbox.senderName = 'Test sender';

      if (this.campaign.sendUntil) {
        this.outbox.sendUntil = this.campaign.sendUntil;
      }

      this.outbox.isSingle = true;


      this.subs.sink = this.antiForgery.getAFToken().subscribe(afResp => {
        if (afResp.hasErrors) {
          Toast.Show(afResp.error, 'Send preview campaign', 'error');
        } else {
          this.subs.sink = this.repository.post<Outbox>('api/MsgOutbox/Create', this.outbox, afResp.data).pipe(map(x => x)).subscribe(outboxResp => {
            if (outboxResp.statusCode == 200) {
              Toast.Show('Preview successfully created.', 'Send campaign', 'success');
              this.spinnerBtn.fadeOut('fast', function () {
                that.successIcon.fadeIn('fast');
              });
            } else {
              Toast.Show(outboxResp.error, 'Send preview campaign', 'error');
              this.spinnerBtn.fadeOut('fast', function () {
                that.errorIcon.fadeIn('fast');
              });
            }
          });
        }
      });
    }
  }

  private onSaveCompleted(data: Campaign) {
    this.saved.emit(data);
    this.onClosed();
  }

  private countCharacters() {
    this.container = $('#counter');
    this.msgNum = $('#msgNum');

    let text = this.campaign.content;
    let ascii = Buffer.from(text, 'ascii');
    let utf8 = Buffer.from(text, 'utf8');

    this.container[0].innerText = 'Total characters: ' + (text.length);

    if (ascii.byteLength != utf8.byteLength) {
      let utf8MsgSize = 70;
      let utf8MessageNum = Math.ceil((text.length) / utf8MsgSize);
      this.msgNum[0].innerText = '';

      if (utf8MessageNum > 1)
        this.msgNum[0].innerText += ' ' + '(' + utf8MessageNum + ' messages)';
    } else {
      let asciiMsgSize = 160;
      let asciiMessageNum = Math.ceil((text.length) / asciiMsgSize);
      this.msgNum[0].innerText = '';

      if (asciiMessageNum > 1)
        this.msgNum[0].innerText += ' ' + '(' + asciiMessageNum + ' messages)';
    }
  }

  private removeDiacritics() {
    if (this.campaign.isDiacritic == true) {
      let diacritic = 'ŠšČčĆćĐđŽž';
      let withoutDiacritic = "SsCcCcDdZz";
      
      let textArr = this.campaign.content.split('');
      let diacriticIndex;

      for (let i = 0; i < textArr.length; i++) {
        if ((diacriticIndex = diacritic.indexOf(textArr[i])) != -1) {
          textArr[i] = withoutDiacritic[diacriticIndex];
        }
      }

      this.campaign.content = textArr.join('');
      this.countCharacters();
    }
  }

  private searchTokens() {
    const regex = new RegExp(/%%\w+( ?-?\/?\w+)*%%/, "g");
    const nonWordChar = /[^a-zA-Z\d\s:]/g;

    let matches = this.campaign.content.match(regex);

    if (matches !== null)
      matches = matches.map(x => x.replace(nonWordChar, '').toUpperCase());

    return matches;
  }

  private setTokenToUpperCase(content: string) {
    const regex = new RegExp(/%%\w+( ?-?\/?\w+)*%%/, "g");

    var tokenToUpper = content.replace(regex, (match) => {
      return match.toUpperCase();
    });

    return tokenToUpper;
  }

  private selectPlainText() {
    this.isPlainText = !this.isPlainText;
  }

  private stripHtmlTags(content: string): string {
    return content.replace(/<[^>]*>?/gm, '');
  }

  private phoneNumValidation(e) {
    let phoneNum: string = e.target.value;

    if (phoneNum[0] !== '+') {
      this.isPhoneValid = false;
    } else {
      this.isPhoneValid = true;
    }
  }

  private onPnoneNumBlur(e) {
    let phoneNum: string = e.target.value;

    if (phoneNum == '') {
      this.isPhoneValid = true;
    }
  }

  private appendLeadingZeroes(n) {
    if (n <= 9) {
      return "0" + n;
    }
    return n
  }

  private onClosed() {
    this.campaign = new Campaign();
    this.outbox = new Outbox();
    this.selectedCamapaign = 0;
    this.editForm.reset();
    $('#counter').html('Total characters: 0');
    $('#plainTexMsg').prop('checked', false);
    this.isPlainText = false;
    this.onSendOn = false;
    this.onSendUntil = false;
    this.selectContactList.selectedContactList = [];
    this.selectedSendOn = undefined;
    this.selectedSendUntil = undefined;
    this.previewCampaignRecepient = '';
    this.spinnerBtn.hide();
    this.successIcon.hide();
    this.errorIcon.hide();
    this.validateTokens.resetContactListTokenError();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();

    this.wizard.Destroy();
    this.wizard = null;
  }
}

export class Outbox {
  id: number;
  idCampaign: number;
  uid: string;
  sender: string;
  recepient: string;
  subject: string;
  body: string;
  uidRecepient: string;
  distributionMechanism: string;
  createdDate: string;
  isSending: boolean;
  isDeleted: boolean;
  lastChangedAt: string;
  isDirty: boolean;
  senderName: string;
  isHTML: boolean;
  isFailedSending: boolean;
  eventCategory: string;
  hasAttachments: boolean;
  bcc: string;
  cc: string;
  sendUntil: string;
  isSingle: boolean;
}

export class CampaignContactList {
  id: number;
  idContactList: number[];
  idCampaign: number;
}
